import { type NextProfitsTotalResponse, nextProfitsTotalResponseSchema } from 'investments/common/definitions'

import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { type UseQueryRequestOptions, useQueryRequest } from '~/ui/hooks/utils/service/use-query-request'

async function fetchMarketNextProfitsTotal({ accountId }: { accountId: string }) {
  const { data } = await httpClientBanking({
    url: `/investments/accounts/${accountId}/storefront/next_profits/total`,
    method: 'GET'
  })

  return nextProfitsTotalResponseSchema.parse(data)
}

export function getUseFetchMarketNextProfitsTotalKey(accountId: string) {
  return ['useFetchMarketNextProfitsTotal', accountId] as const
}

export function useFetchMarketNextProfitsTotal({
  accountId,
  options
}: {
  accountId: string
  options?: UseQueryRequestOptions<NextProfitsTotalResponse, unknown, true>
}) {
  return useQueryRequest<NextProfitsTotalResponse, unknown, true>(
    getUseFetchMarketNextProfitsTotalKey(accountId),
    () => fetchMarketNextProfitsTotal({ accountId }),
    {
      suspense: false,
      retry: false,
      ...options
    }
  )
}
